import { render, staticRenderFns } from "./OfferItemCourse.vue?vue&type=template&id=50b1a869"
import script from "./OfferItemCourse.vue?vue&type=script&lang=js"
export * from "./OfferItemCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b1a869')) {
      api.createRecord('50b1a869', component.options)
    } else {
      api.reload('50b1a869', component.options)
    }
    module.hot.accept("./OfferItemCourse.vue?vue&type=template&id=50b1a869", function () {
      api.rerender('50b1a869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/OfferItemCourse.vue"
export default component.exports